export default {
  'APP_UPDT_FULFILLMENT_FACILITY': 'APP_UPDT_FULFILLMENT_FACILITY',
  'APP_UPDT_PICKER_CONFG': 'APP_UPDT_PICKER_CONFG',
  'APP_UPDT_BLOCK_LOGIN': 'APP_UPDT_BLOCK_LOGIN',
  'APP_UPDT_PASSWORD': 'APP_UPDT_PASSWORD',
  'APP_UPDT_PRODUCT_STORE_CONFG': 'APP_UPDT_PRODUCT_STORE_CONFG',
  'APP_SUPER_USER': 'APP_SUPER_USER',
  'APP_SECURITY_GROUP_CREATE': 'APP_SECURITY_GROUP_CREATE',
  'APP_SECURITY_GROUP_ASSIGNMENT': 'APP_SECURITY_GROUP_ASSIGNMENT',
  'APP_PERMISSION_CREATE': 'APP_PERMISSION_CREATE',
  'APP_PERMISSION_UPDATE': 'APP_PERMISSION_UPDATE',
  'APP_PERMISSION_VIEW': 'APP_PERMISSION_VIEW',
  'APP_USER_CREATE': 'APP_USER_CREATE',
  'APP_USER_PROFILE_UPDATE': 'APP_USER_PROFILE_UPDATE',
  'APP_USER_STATUS_UPDATE': 'APP_USER_STATUS_UPDATE',
  'APP_USER_CONTACT_CREATE': 'APP_USER_CONTACT_CREATE',
  'APP_USER_CONTACT_UPDATE': 'APP_USER_CONTACT_UPDATE',
  'APP_USER_CONTACT_DELETE': 'APP_USER_CONTACT_DELETE',
  'APP_COMMERCE_VIEW': 'APP_COMMERCE_VIEW',
  'APP_PWA_STANDALONE_ACCESS': 'APP_PWA_STANDALONE_ACCESS',
  'APP_USERS_LIST_VIEW': 'USERS_LIST_VIEW'
}
